// bower lib requires
import $ from 'jquery';
import NProgress from 'nprogress';
import 'foundation-sites/js/foundation';
import 'velocity-animate';
import 'rangeslider.js';

// global requires
import config from './../modules/globals/config';
import universal from './../modules/globals/universal';
import velocityAnims from './../modules/globals/velocity-animations';

// local module requires
import search from './../modules/search';
import flexsliderStart from './../modules/flexslider-start';
import videoPlayerStart from './../modules/video-player-start';
import setActiveColor from './../modules/set-active-color';
import trailerSlicesMove from './../modules/trailer-slices-move';
import animate from './../modules/animate';
import videoLoad from './../modules/video-load';
import homepageAnimations from './../modules/homepage-animations';
import videoEvents from './../modules/video-events';
import videoPoster from './../modules/video-poster';
import replaceGWIIcons from './../modules/gwi-icon-replacer';

// trailer scroll start

// local vars
let $document = $(document),
  body = $('body'),
  overlay = $('#overlay'),
  logo = $('.name h1'),
  flexsliderCont = $('.flexslider');

// desktop only vars
let trailersNav = $('#trailersNav'),
  navWidth = trailersNav.outerWidth(),
  navScrollWidth = trailersNav[0].scrollWidth,
  trailersSlices = $('#trailersSlices'),
  trailersSlice = trailersSlices.find('li'),
  first = $('.first'),
  firstCont = first.find('a'),
  footer = $('footer'),
  footerLi = footer.find('ul li, .footer-logos, .footer-copyright'),
  header = $('header'),
  headerLi = header.find('.top-bar-section ul li'),
  trailersSlicesA = trailersSlices.find('a').not('.first-a'),
  trailersSlicesB = trailersSlices.find('a'),
  videoCont = $('.video-js'),
  loadingSpinner = $('.vjs-loading-spinner'),
  widthDiff = navScrollWidth / navWidth - 1,
  area = navWidth - 2 * config.mouseMovePadding,
  areaRatio = navWidth / area,
  inputRange = $('input[type="range"]');

/*
  Startup
 */
// start foundation responsive
$document.foundation();

// nprogress
NProgress.configure({ showSpinner: false });
NProgress.start();

let universalInit = new universal();

config.currentPage = 'homepage';
config.isMobile = universalInit.isMobileDevice();
config.isiPad = universalInit.isiPad();
config.isAndroid = universalInit.isAndroid();

// determine current active trailer color
setActiveColor(body, trailersSlices);

// set up velocity ui registrations
velocityAnims();

// replace gowatch it icons with custom on load
replaceGWIIcons();

homepageAnimations(headerLi, footerLi, trailersSlicesA, logo, first, firstCont, videoCont, overlay, function () {
  trailerSlicesMove(body, trailersSlicesB, headerLi, footerLi, videoCont, area, areaRatio);
});

if (config.theWindow.width() <= 640 || config.isiPad || config.isAndroid) {
  // initiate flexslider for mobile
  flexsliderStart(flexsliderCont, body);

} else {
  videoPoster.init($('.home-video-poster'), trailersSlice);

  jQuery.support.cors = true;

  $.get(window.location.origin + '/?__api=1&films=featured', function (response) {
    config.featuredTrailersJSON = response.data;
    config.max = response.data.length - 1;

    inputRange.rangeslider({ polyfill: false });

    // start animate and bind trailer slice movements
    animate(widthDiff, trailersSlices);

    // brightcove
    let videoId = $('.active').data('video-id');
    videoPlayerStart(loadingSpinner, videoId, 'main', videoPoster);
  });
}

search.init();
/*
  Events
 */
// click events
$('.toggle-topbar.mobile-menu-icon').on('click', function (e) {
  e.preventDefault();

  $(this).toggleClass('active');

  // toggle pause of flexslider if mobile menu expanded
  if ($('.top-bar').hasClass('expanded')) {
    flexsliderCont.flexslider('play');
  } else {
    flexsliderCont.flexslider('pause');
  }
});

function trailerSliceOnClick (e) {
  e.preventDefault();

  if ($(this).hasClass('active')) {
    return;
  }

  // remove click event so user cant overload safari
  if (!body.hasClass('not-safari')) {
    trailersSlice.off('click', trailerSliceOnClick);
    setTimeout(function () {
      trailersSlice.on('click', trailerSliceOnClick);
    }, 4000);
  }

  $('.trailers-scroll .meter').css('width', 0);
  $('.trailers-scroll input[type="range"]').val(0).change();

  NProgress.start();

  let active = trailersSlices.find('.active');
  active.removeClass('active').removeClass('header-larger').find('a').css('bottom', '');
  config.myPlayer.pause();

  let nextActive = $(this);
  nextActive.addClass('active').find('a').css('bottom', '');

  setTimeout(function () {
    nextActive.addClass('header-larger');
  }, 150);

  videoPoster.loadNext();

  if ($(e.target).hasClass('play-trailer') || !config.isMute) {
    if (config.isMute) {
      config.isMute = false;
      config.myPlayer.volume(1);
      config.myPlayer.muted(false);
    }
    nextActive.find('.mute').removeClass('hide');
    nextActive.find('.unmute').addClass('hide');
  } else {
    nextActive.find('.mute').addClass('hide');
    nextActive.find('.unmute').removeClass('hide');
  }

  setActiveColor(body, trailersSlices);

  let videoId = nextActive.data('video-id');

  // wait for the animation
  setTimeout(function () {

    videoLoad(loadingSpinner, videoId, config.myPlayer);

    $('input[type="range"]', nextActive).rangeslider('update', true);

    new videoEvents(config.myPlayer);

  }, 1000);
}

trailersSlice.on('click', trailerSliceOnClick);

$('.see-more').on('click', function (e) {
  e.stopPropagation();
  e.preventDefault();

  window.location.href = $(this).data('href');
});

// trailer button click
$('.single-trailer').on('click', function (e) {
  e.preventDefault();

  let videoId = $(this).data('video-id');
  let title = $(this).data('title');

  let modal = $('.reveal-modal-bg');

  if (typeof modal !== 'undefined') {
    modal.css({ 'display': 'block', 'opacity': '1' });
  }

  // open foundation modal with video player
  $('#trailerModal').foundation('reveal', 'open', {
    data: { videoId: videoId, title: title },
  });
});


$document.on('click', '.close-modal', function (e) {
  e.preventDefault();

  if (config.myPlayer !== null) {
    let myPlayerEvents = new videoEvents(config.myPlayer);
    myPlayerEvents.stopVideoPlayer();
  }

  setTimeout(function () {

    // reset myPlayer
    config.myPlayer = null;

    // recreate foundation close modal so that display doesn't get set to none and cause player issues
    $('#trailerModal, #videoModal').velocity({ opacity: 0 }, {
      duration: config.animationTiming,
      easing  : config.easing,
      complete: function () {
        $(this).css({ visibility: 'hidden' }).removeClass('open');
      },
    });

    $('.reveal-modal-bg').velocity({ opacity: 0 }, {
      duration: config.animationTiming,
      easing  : config.easing,
      display : 'none',
    });
  }, 0);
});


// listen events
// rangeslider input listen
$document.on('input', inputRange, function (e) {
  if (e.target.type !== 'range') {
    return;
  }
  let value = e.target.value;

  let myPlayerEvents = new videoEvents(config.myPlayer);
  myPlayerEvents.seek(value);
});


// modal open listen
$document.on('opened.fndtn.reveal', '[data-reveal]', function () {
  let modal = $(this);

  // grab video id and title from passed in data params
  if (typeof (modal.data('revealInit').data) !== 'undefined') {
    let videoId = modal.data('revealInit').data.videoId;
    let videoTitle = modal.data('revealInit').data.title;

    $('#videoModalTitle').text(videoTitle);

    if (modal.context.id === 'videoModal') {
      videoPlayerStart(loadingSpinner, videoId, 'main');
    } else if (modal.context.id === 'trailerModal') {
      videoPlayerStart(loadingSpinner, videoId, 'trailer');
    }
  }
});
